<template>
    <div>
        <v-dialog v-model="dialog" width="800" persistent>
            <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%">
                <v-card-title style="
          background-color: #373f49 !important;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: white;
        ">
                    <div>
                        <span class="font-weight-bold text-h6" style="font-family: Saira Condensed, sans-serif">{{
                            main_title }}</span>
                        <div class="text-caption" style="font-family: Saira Condensed, sans-serif">
                            {{ sub_title }}
                        </div>
                    </div>
                    <v-btn :disabled="loading" flat icon color="primary" @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text style="overflow-y: auto; max-height: calc(100vh - 200px)">
                    <v-form ref="form" class="mt-4">
                        <v-row dense>
                            <v-col v-if="action == 'add'" cols="12" md="6">
                                <v-select v-model="leaderboardType" label="Leaderboard Type" variant="outlined"
                                    density="comfortable" color="primary"
                                    style="font-family: Saira Condensed, sans-serif" :items="leaderboardTypes"
                                    :loading="loadingLeaderboardTypes" item-title="name" item-value="value">
                                </v-select>
                            </v-col>

                            <!-- <v-col cols="12" md="6">
              <v-select
                v-model="status"
                label="Status"
                variant="outlined"
                density="comfortable"
                color="primary"
                style="font-family: Saira Condensed, sans-serif"
                :items="leaderboardStatus"
                item-title="name"
                item-value="value"
              >
              </v-select>
            </v-col> -->

                            <!-- <v-col cols="12" class="mb-2 d-flex">
                            <p class="text-subtitle-2 font-weight-bold">Note:&nbsp;</p>
                            <p class="text-subtitle-2">Start Date and End Date set will be all inclusive</p>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field v-model="startDate" :rules="[formRules.required]" label="Start Date" type="date"
                                variant="outlined" density="comfortable" color="primary"
                                style="font-family: Saira Condensed, sans-serif;"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field v-model="endDate" :rules="[formRules.required]" label="End Date" type="date"
                            variant="outlined" density="comfortable" color="primary"
                            style="font-family: Saira Condensed, sans-serif;"></v-text-field>
                        </v-col> -->
                        </v-row>
                    </v-form>

                    <!-- <div
          v-if="startDate && endDate"
          class="text-subtitle-2 text-center my-2"
          style="font-family: Saira Condensed, sans-serif"
        >
          {{ getLeaderboardTypeName(leaderboardType) }} Milestones will start
          within {{ formatDate(startDate) }} 00:00 UTC to
          {{ formatDate(endDate) }} 23:59 UTC
        </div> -->

                    <!-- Weekly Wager Section -->
                    <v-divider class="my-4"></v-divider>
                    <h3 class="text-subtitle-2 font-weight-bold mb-2" style="font-family: Saira Condensed, sans-serif">
                        Wager Tiers
                    </h3>

                    <div v-for="(wager, index) in weeklyWagers" :key="index" class="mb-2">
                        <v-row dense no-gutters align="center">
                            <!-- Circle badge with ordinal -->
                            <v-col cols="12" md="1" class="d-flex justify-center">
                                <div class="text-caption font-weight-bold d-flex align-center justify-center" style="
                  width: 38px;
                  height: 38px;
                  border-radius: 50%;
                  background-color: #e0e0e0;
                  font-family: 'Saira Condensed', sans-serif;
                  color: #333;
                ">
                                    {{ index + 1 }}
                                </div>
                            </v-col>

                            <v-col cols="12" md="5" class="px-1">
                                <v-text-field v-model="wager.wager" label="Wager Requirement" variant="outlined"
                                    density="comfortable" color="primary" hide-details
                                    :rules="action === 'add' ? [formRules.required] : []"
                                    style="font-family: Saira Condensed, sans-serif" />
                            </v-col>

                            <v-col cols="12" md="5" class="px-1">
                                <v-text-field v-model="wager.reward" label="Tier Rewards" variant="outlined"
                                    density="comfortable" color="primary" hide-details
                                    :rules="action === 'add' ? [formRules.required] : []"
                                    style="font-family: Saira Condensed, sans-serif" prefix="$" />
                            </v-col>

                            <!-- Remove button -->
                            <v-col cols="12" md="1" class="d-flex justify-center">
                                <v-btn icon @click="removeWager(index)">
                                    <v-icon color="error">mdi-delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <v-btn class="mt-2" color="primary" variant="outlined" block @click="addWager"
                        style="font-family: Saira Condensed, sans-serif">
                        <v-icon left>mdi-plus</v-icon>Add Wager Tier
                    </v-btn>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-3" style="margin-top: auto">
                    <v-spacer></v-spacer>
                    <v-btn class="mr-1 text-subtitle-1" :disabled="loading" text="Cancel" variant="outlined"
                        elevation="1" @click="closeDialog()" style="font-family: Saira Condensed, sans-serif"></v-btn>
                    <v-btn class="mr-1 text-subtitle-1" :loading="loading" :disabled="!isFormValid || loading"
                        text="Save" variant="elevated" elevation="1" color="primary" @click="validateForm()"
                        style="font-family: Saira Condensed, sans-serif">
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar" :timeout="2500" color="secondary" location="top">
            <v-icon>mdi-alert-circle</v-icon>
            <span class="ml-2" style="font-family: Saira Condensed, sans-serif">{{
                snackText
                }} </span>
        </v-snackbar>
    </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
    emits: ["refresh"],
    data() {
        return {
            dialog: false,
            main_title: null,
            sub_title: null,
            action: null,
            loading: false,

            snackbar: false,
            snackText: null,

            id: null,
            startDate: null,
            endDate: null,
            status: null,
            leaderboardType: null,
            status: null,

            formRules: {
                required: (value) => !!value || "This field is required",
            },

            weeklyWagers: [
                {
                    wager: "",
                    reward: "",
                },
            ],

            statusTypes: [
                { name: "Active", value: "active" },
                { name: "Current", value: "current" },
                { name: "Previous", value: "previous" },
            ],

            leaderboardTypes: [
                { name: "Stake", value: "stake" },
            ],

            leaderboardStatus: [
                { name: "Active", value: "active" },
                { name: "Draft", value: "draft" },
            ],
        };
    },
    computed: {
        isFormValid() {
            if (this.loading) return false;

            // Check weekly wagers for both "add" and "edit" modes
            if (this.action === "add" || this.action === "edit") {
                const areWagersValid = this.weeklyWagers.every(
                    (w) => w.wager && w.reward
                );
                return areWagersValid;
            }

            return false;
        },
    },
    methods: {

        addWager() {
            this.weeklyWagers.push({
                wager: "",
                reward: "",
            });
        },
        removeWager(index) {
            this.weeklyWagers.splice(index, 1);
        },
        async initAdd() {
            this.dialog = true;
            this.main_title = "Add Milestone";
            this.sub_title = "Milestone Information";
            this.action = "add";

            this.weeklyWagers = [
                {
                    wager: "",
                    reward: "",
                },
            ];
        },
        async initUpdate(data) {
            this.main_title = "Edit Milestone";
            this.sub_title = "Milestone Information";
            this.action = "edit";


            this.id = data._id;
            this.leaderboardType = data.leaderboardType;
            this.status = data.status;
            this.weeklyWagers = data.milestones?.map((milestone) => ({
                wager: milestone.requiredWager,
                reward: milestone.reward,
            })) || [
                    { wager: "", reward: "" },
                ];

            this.dialog = true;
            this.loading = false;
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString("en-CA");
        },
        async validateForm() {
            const { valid } = await this.$refs.form.validate();

            if (!valid) return;

            this.loading = true;
            const token = localStorage.getItem("maherco-admin-accesstoken");

            const payload = {
                leaderboardType: this.leaderboardType,
                milestones: this.weeklyWagers.map(wager => ({
                    requiredWager: parseFloat(wager.wager),
                    reward: parseFloat(wager.reward)
                })),
            };

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
                },
            };

            try {
                let response;
                if (this.action === "add") {
                    response = await axios.post(
                        `${process.env.VUE_APP_SERVER_URL}/api/admin/wager-rewards`,
                        payload,
                        config
                    );
                } else if (this.action === "edit") {
                    response = await axios.patch(
                        `${process.env.VUE_APP_SERVER_URL}/api/admin/wager-rewards/${this.id}`,
                        payload,
                        config
                    );
                }

                if (response?.data) {
                    this.snackText =
                        this.action === "add"
                            ? "Milestone Successfully Added!"
                            : "Milestone Successfully Updated!";
                    this.snackbar = true;
                    this.$emit("refresh");
                    this.closeDialog();
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("maherco-admin-accesstoken");
                    window.location.reload();
                } else if (error.response?.status === 400) {
                    this.snackText = error.response.data.message;
                    this.snackbar = true;
                } else {
                    console.error("Unexpected Error:", error);
                }
            } finally {
                this.loading = false;
            }
        },
        closeDialog() {
            this.$refs.form.reset();
            this.dialog = false;
            this.weeklyWagers = [
                {
                    wager: "",
                    reward: "",
                },
            ];
        },
        getOrdinal(n) {
            const s = ["th", "st", "nd", "rd"],
                v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        },

        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        formatReadableDate(date) {
            return new Date(date).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
            });
        },
        getCurrentWeekRangeUTC() {
            const now = new Date();

            const currentDay = now.getUTCDay();

            const monday = new Date(
                Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
            );
            monday.setUTCDate(monday.getUTCDate() - ((currentDay + 6) % 7));
            monday.setUTCHours(0, 0, 0, 0);

            const sunday = new Date(monday);
            sunday.setUTCDate(monday.getUTCDate() + 6);
            sunday.setUTCHours(23, 59, 0, 0);

            return {
                startDate: monday.toISOString().slice(0, 10),
                endDate: sunday.toISOString().slice(0, 10),
            };
        },
    },

});
</script>

<style scoped></style>
